import React, { FunctionComponent, useContext, useMemo } from 'react';
import classNames from 'classnames/bind';
import { AppDeviceSize } from '../../enums/app-device-size';
import { AppStore } from '../../store/app.context';
import styles from './image-feature-with-link.module.scss';
import { ExternalLink } from '../external-link/external-link';
import { InternalLink } from '../internal-link/internal-link';
import AnchorLink from 'react-anchor-link-smooth-scroll';

const cx = classNames.bind(styles);

export interface IImageFeatureWithLinkProps {
  imageSize: string;
  imgAsset: string;
  linkToExternal?: string | undefined;
  linkToInternal?: string | undefined;
  withBorder: boolean;
  hasGrayscaleFilter: boolean;
  opacity: number;
  customHeight: number;
  scrollToSection?: string | undefined;
}

export const ImageFeatureWithLink: FunctionComponent<IImageFeatureWithLinkProps> = props => {
  const {
    imageSize,
    imgAsset,
    linkToExternal,
    linkToInternal,
    withBorder,
    hasGrayscaleFilter,
    opacity,
    customHeight,
    scrollToSection
  } = props;

  const { state } = useContext(AppStore);
  const { showActiveDevice } = state;

  const className = cx({
    small: imageSize === 'small',
    medium: imageSize === 'medium',
    large: imageSize === 'large',
    extraLarge: imageSize === 'extra_large'
  });

  const wrapperClass = cx({
    withBorder: withBorder ? true : false
  });

  const imageHeight = useMemo(() => {
    if (!customHeight) {
      return false;
    }

    if (showActiveDevice <= AppDeviceSize.MOBILE) {
      return customHeight * 0.7;
    }
    return customHeight;
  }, [showActiveDevice, customHeight]);

  const image = (
    <img
      style={{
        height: imageHeight ? imageHeight : '',
        opacity: opacity ? opacity / 100 : 1
      }}
      src={imgAsset}
      className={`${className} ${hasGrayscaleFilter && styles.image}`}
      alt="Element"
    />
  );

  return (
    <div className={`${wrapperClass} ${styles.wrapper}`}>
      {linkToExternal && (
        <ExternalLink url={linkToExternal}>{image}</ExternalLink>
      )}
      {linkToInternal && (
        <InternalLink url={linkToInternal}>{image}</InternalLink>
      )}
      {scrollToSection && (
        <AnchorLink offset="100" href={`#${scrollToSection}`}>
          {image}
        </AnchorLink>
      )}
      {!linkToExternal && !linkToInternal && !scrollToSection && image}
    </div>
  );
};
